
import { useState, useRef, useEffect, useContext } from 'react';

// import { Menubar } from 'primereact/menubar';
import { useSelector, useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';

import { useShared } from '../Utilities/allContext1';
import Assign from '../Components/Assign';
import Menubar1 from '../Components/Menubar1';

import reducer from '../Imports/reducerImports';

import { useMenuItems, DISPLAY_MODES, DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from '../Utilities/constant';
import { addNumber2MemberList, getChip, getFace, updateManagerSupervisorList, sortMemberList, isSelected, getServiceListItem } from '../Utilities/common';

import { SelectButton } from 'primereact/selectbutton';
import { ProgressSpinner } from 'primereact/progressspinner';
      
import Masonry from 'react-masonry-css';
//import '../Css/App.css'; // Optional: If you want to use an external CSS file
//import { setMemberList } from '../Redux/allReducer';

export default function Home() {

    // const navigate = useNavigate();

    const { setUserListItem, setMemberList, setDisplayMode, reset4All } = reducer;
    const { getUserListItem, getDistrictList, getSupervisorList, getManagerList, getAssignList, updateAssignList, getServiceList, getMemberList } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const memberList = useSelector((state) => state.all.memberList);
    const assignList = useSelector((state) => state.all.assignList);
    const serviceList = useSelector((state) => state.all.serviceList);
    const managerList = useSelector((state) => state.all.managerList);
    const supervisorList = useSelector((state) => state.all.supervisorList);
    const districtList = useSelector((state) => state.all.districtList);
    const displayMode = useSelector((state) => state.all.displayMode);  
    const userListItem = useSelector((state) => state.all.userListItem); 

    const [spinnerOn, setSpinnerOn] = useState(false);

    const styles = {
        container: {
            display: 'flex',
            justifyContent: 'center', // Center horizontally
            alignItems: 'center', // Center vertically
            height: '100vh', // Full viewport height
            width: '100vw', // Full viewport width
            position: 'absolute', // Positioning to fill the viewport
            top: 0,
            left: 0,
        },
    };

    const onChangeDisplayMode = (e) => {
        dispatch(setDisplayMode(e.value));
    }

    // useEffect(() => {
    //     if (districtList.length === 0) getDistrictList();
    // }, []);

    useEffect(() => {
        //setSpinnerOn(true);
        if (memberList.length === 0) getMemberList();    
        // if (assignList.length === 0) getAssignList();
        if (serviceList.length === 0) getServiceList();
        // if (managerList.length === 0) getManagerList();    
        if (supervisorList.length === 0) getSupervisorList();
        // setSpinnerOn(false);
        //districtList
        if (districtList.length === 0) getDistrictList();
        if (userListItem === null) getUserListItem();
    }, []);

    const areListsReady = 
        memberList.length > 0 &&
        assignList.length > 0 &&
        serviceList.length > 0 &&
        managerList.length > 0 &&
        supervisorList.length > 0;

    return (
        <div>
            {/* <Menubar model={menuItems} style={{ backgroundColor: 'lightBlue' }}/> */}
            <Menubar1 />
            {/* <div className="card flex justify-content-center" style={{ margin: '5px', padding: '5px' }}>
                <SelectButton value={selectButtonOption} onChange={onChangeSelectButton} options={selectButtonOptions}/>
            </div> */}
            <div className="flex flex-wrap justify-content-center flex-wrap gap-3" style={{ margin: '5px', padding: '5px' }}>
                <SelectButton value={displayMode} onChange={onChangeDisplayMode} options={DISPLAY_MODES} optionLabel="name"/>
            </div>
            <Masonry
                breakpointCols={{ default: 5, 1100: 3, 700: 2, 500: 1 }} // Adjust breakpoints as needed
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
            >
                {areListsReady &&
                serviceList.map((service) => (
                    <Assign serviceListItem={service} displayMode={displayMode} modify={true}/>
                ))
                }
            </Masonry>
            {/* {!areListsReady && <div style={styles.container}><ProgressSpinner style={{width: '250px', height: '250px'}} strokeWidth="1" /></div>} */}
            {!areListsReady && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.3)', // Semi-transparent black backdrop
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999 // Ensures it sits on top of absolutely everything
                }}>
                    <ProgressSpinner style={{width: '250px', height: '250px'}} strokeWidth="1" />
                </div>
            )}             
        </div>
    )

}